module.exports = __webpack_public_path__ + "static/img/IMG_20151231_122426.268ab231.jpg";